var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"busyBar"}},[(_vm.isBusy)?_c('progress',{staticClass:"progress is-small is-primary",attrs:{"max":"100"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }